// src/components/common/RoleProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleProtectedRoute = ({ children, currentUserProfile, allowedRoles }) => {
    // 1. If profile is still loading, return nothing
    if (!currentUserProfile) return null;

    const userRole = currentUserProfile.role || 'User';

    // 2. DEFINE "GOD MODE" ROLES
    // These roles bypass ALL permission checks. They can see everything.
    const SUPER_ADMIN_ROLES = [
        'Admin', 
        'Owner', 
        'Owner/System Admin', 
        'Owner / System Admin', 
        'System Admin'
    ];

    // 3. THE MASTER KEY CHECK
    if (SUPER_ADMIN_ROLES.includes(userRole)) {
        return children;
    }

    // 4. Standard Check for everyone else (Managers, Staff, etc.)
    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/" replace />;
    }

    // 5. Access Granted
    return children;
};

export default RoleProtectedRoute;